import { Component, forwardRef, signal } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-products',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [
    { provide: TabComponent, useExisting: forwardRef(() => ProductsComponent) },
  ],
  templateUrl: './products.component.html',
  styleUrl: './products.component.scss',
})
export class ProductsComponent extends TabComponent {
  override name: string = this.dictionaryService.get('ProductsPerformance');

  onInit() {
    // Don't initialize on component init
  }

  public async main(): Promise<void> {}
}
